<template>
  <div class="date-container">
    <DashboardCalendarPicker
      id="benchmarks-header-calendar"
      class="initial-calendar"
      :value="initialDateValue"
      :minDate="minDate"
      :maxDate="maxDate"
      :isMultipleOptionVariant="true"
      :show="initialShow"
      @applyContinueClick="handleApplyContinue"
      @controlClick="initialCalendarClick"
      @click="handleApply"
    ></DashboardCalendarPicker>
    <span>compared to</span>
    <DashboardCalendarPicker
      id="benchmarks-header-calendar"
      class="comparison-calendar"
      :value="formattedComparisonDateValue"
      :minDate="minDate"
      :maxDate="maxDate"
      :show="compareShow"
      :isMultipleOptionVariant="false"
      @controlClick="compareCalendarClick"
      @click="handleComparisonApply"
    ></DashboardCalendarPicker>
  </div>
</template>

<script>
import DashboardCalendarPicker from '../../Common/DashboardCalendarPicker.vue';

export default {
  props: {
    initialDateValue: {
      type: Object,
    },
    comparisonDateRange: {
      type: Object,
    },
    comparisonPredefinedRangeValue: {
      type: Number,
    },
    minDate: {
      type: [Date, Number],
    },
    maxDate: {
      type: [Date, Number],
    },
  },
  components: {
    DashboardCalendarPicker,
  },
  data() {
    return {
      compareShow: false,
      initialShow: false,
    };
  },
  computed: {
    formattedComparisonDateValue() {
      return {
        range: this.comparisonDateRange,
        predefinedRangeValue: this.comparisonPredefinedRangeValue,
      };
    },
  },
  methods: {
    handleApplyContinue(val) {
      this.compareShow = false;
      this.$nextTick(() => this.compareShow = true);
      this.$emit('updateInitialDateRange', val);
    },
    handleApply(val) {
      this.$emit('applyInitialDateRange', val);
    },
    handleComparisonApply(val) {
      this.$emit('applyComparisonCustomDateRange', val);
    },
    initialCalendarClick(currentState) {
      this.initialShow = currentState;
      this.compareShow = false;
    },
    compareCalendarClick(currentState) {
      this.compareShow = currentState;
      this.initialShow = false;
    },
  },
};
</script>

<style scoped>
.date-container {
  display: flex;
  align-items: center;
  padding-right: 24px;
}

.date-container > span {
  display: inline-block;
  white-space: nowrap;
  margin: 0px 16px;
  color: #778699;
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
}

.date-container > .wrapper {
  max-width: 200px;
}

#benchmarks-header-calendar {
  width: 300px;
  height: 0;
}
</style>

<style>
.benchmarks-header #benchmarks-header-calendar .picker-container.dropdown {
  right: 0;
  z-index: 2;
}

.benchmarks-header #benchmarks-header-calendar .date-range-control-wrapper {
  background: transparent;
  top: -21px;
}

.benchmarks-header #benchmarks-header-calendar .date-range-control {
  background: #FFFFFF;
  cursor: pointer;
}

.benchmarks-header #benchmarks-header-calendar span.date {
  display: inline-block;
  white-space: nowrap;
  padding-left: 4px;
  padding-right: 4px;
}

.benchmarks-header #benchmarks-header-calendar .help-text {
  background: transparent;
  padding: 0 12px;
  z-index: 2;
}
</style>
